const records = new Map();

/**
 * Return the record map for one resource.
 * @param {string} resource resource identifier
 * @return {Map} resource records
 */
function resourceRecords(resource) {
	if (!records.has(resource)) records.set(resource, new Map());
	return records.get(resource);
}

/**
 * Replace the locally retained records for a resource.
 * @param {string} resource resource identifier
 * @param {Array} rows Canvas rows
 * @param {Function} getId row identifier function
 * @return {void}
 */
export function replaceResolvedEntities(resource, rows, getId) {
	const values = resourceRecords(resource);
	values.clear();
	rows.forEach((row) => {
		const id = getId(row);
		if (id != null && String(id).trim()) values.set(String(id), row);
	});
}

/**
 * Resolve a locally retained Canvas row.
 * @param {string} resource resource identifier
 * @param {string} entityId entity identifier
 * @return {object|null} Canvas row
 */
export function getResolvedEntity(resource, entityId) {
	return resourceRecords(resource).get(String(entityId)) || null;
}
